import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Subscription } from 'rxjs';

export interface DeleteSiteConfigurationDialogData {
  location: string;
  siteName: string;
  isActive: boolean;
}

@Component({
  selector: 'app-delete-site-configuration-dialog',
  templateUrl: './delete-site-configuration-dialog.component.html',
  styleUrls: ['./delete-site-configuration-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class DeleteSiteConfigurationDialogComponent implements OnInit, OnDestroy {
  readonly expectedLocation: string;

  form = new FormGroup({
    acknowledged: new FormControl(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    confirmPhrase: new FormControl('', { nonNullable: true })
  });

  private sub = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<DeleteSiteConfigurationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteSiteConfigurationDialogData
  ) {
    this.expectedLocation = (data.location ?? '').trim();
  }

  ngOnInit(): void {
    const phrase = this.form.controls.confirmPhrase;
    phrase.disable();

    this.sub.add(
      this.form.controls.acknowledged.valueChanges.subscribe((checked) => {
        if (checked) {
          phrase.enable();
        } else {
          phrase.disable();
          phrase.setValue('');
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  get canDelete(): boolean {
    if (!this.form.controls.acknowledged.value) {
      return false;
    }
    const typed = this.form.controls.confirmPhrase.value.trim();
    return typed.length > 0 && typed === this.expectedLocation;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirmDelete(): void {
    if (!this.canDelete) {
      return;
    }
    this.dialogRef.close(true);
  }
}
